import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

import { db } from "../../firebase";
import {
  collection,
  getDocs,
  doc,
  onSnapshot,
  addDoc,
  orderBy,
  query,
  setDoc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { 
  getDoc,
 } from "firebase/firestore";
 
 
 
 import NewStarterPayrollAdminReview from "./forms/NewStarterPayrollAdminReview";


// inside your Admin compliance component:



export default function UserManagement() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [chatId, setChatId] = useState(null);
  const [complianceDocs, setComplianceDocs] = useState([]);
  const navigate = useNavigate();


  // 🔹 Load all users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        const data = querySnapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data(),
        }));
        setUsers(data);
      } catch (err) {
        console.error("Error fetching users:", err);
      }
    };
    fetchUsers();
  }, []);
  
  
  // 🧪 TEMP TEST: print what users actually look like
useEffect(() => {
  console.log("Users loaded:", users);
}, [users]);


  // 🔹 Open Chat and Load Compliance
  const openChat = async (user) => {
    if (!user?.id) {
      console.warn("⚠️ Selected user has no ID:", user);
      return;
    }

    setSelectedUser(user);
    const participants = [user.email, "admin@convalesce.com"].sort();
    const chatKey = participants.join("_").replace(/[.@]/g, "_");

    await setDoc(doc(db, "chats", chatKey), { participants }, { merge: true });
    setChatId(chatKey);
    loadCompliance(user.id);
  };

  // 🔹 Listen to messages
  useEffect(() => {
    if (!chatId) return;
    const q = query(
      collection(db, "chats", chatId, "messages"),
      orderBy("timestamp", "asc")
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setMessages(snapshot.docs.map((d) => d.data()));
    });
    return () => unsubscribe();
  }, [chatId]);

  // 🔹 Send message
  const sendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim() || !chatId) return;

    const msg = {
      text: newMessage,
      senderEmail: "admin@convalesce.com",
      senderName: "Admin",
      timestamp: serverTimestamp(),
    };
    await addDoc(collection(db, "chats", chatId, "messages"), msg);
    setNewMessage("");
  };

  // 🔹 Load compliance docs safely
  const loadCompliance = async (userId) => {
    if (!userId) return console.warn("No userId for compliance fetch");
    try {
      const q = collection(db, "users", String(userId), "complianceDocs");
      const snapshot = await getDocs(q);
      const items = snapshot.docs.map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
      }));
      setComplianceDocs(items);
    } catch (err) {
      console.error("Error loading compliance docs:", err);
    }
  };

  // 🔹 Update document status
  const updateStatus = async (userId, docId, newStatus) => {
    try {
      await updateDoc(doc(db, "users", String(userId), "complianceDocs", docId), {
        status: newStatus,
      });
      alert(`Document marked as ${newStatus}`);
      loadCompliance(userId);
    } catch (err) {
      console.error("Error updating status:", err);
    }
  };
const toggleUserRole = async (userId, currentRole, userData) => {
  try {
    // We keep role as "user" to preserve dashboard behavior.
    // "Staff" status is controlled by presence of a staff document.
    await updateDoc(doc(db, "users", userId), {
      role: "user",
      roleUpdatedAt: serverTimestamp(),
    });

    // Update UI instantly (role shown stays "user")
    setUsers((prev) =>
      prev.map((u) => (u.id === userId ? { ...u, role: "user" } : u))
    );

    // Require a real Firebase UID for staff linking
    // Require a real Firebase UID for staff linking
	const firebaseUid = userData?.authUid || null;
	const email = (userData?.email || "").toLowerCase().trim();

	if (!email) {
	  alert(
		"Cannot make staff: this user has no email saved on their user record. " +
		"Open their user document in Firestore and add the email field, then try again."
	  );
	  return;
	}


    if (!firebaseUid) {
      alert(
        "This user has no Firebase Auth UID saved in users.authUid yet. Please have them log in once, then try again."
      );
      return;
    }

    // Check if staff record already exists (match by Firebase UID)
    const staffSnap = await getDocs(collection(db, "staff"));
    const existing = staffSnap.docs.find((s) => s.data().authUid === firebaseUid);

    if (existing) {
	  // If already staff, "Remove Staff" can simply mark inactive (safer than deleting)
	  await updateDoc(doc(db, "staff", existing.id), {
		isActive: false,
		updatedAt: serverTimestamp(),
		// backfill email if it was missing
		email: existing.data()?.email || email,
	  });
	  alert("Staff access removed (staff record marked inactive).");
	  return;
	}


    // Otherwise create staff record (this is the "Make Staff" action)
    await addDoc(collection(db, "staff"), {
      authUid: firebaseUid,              // ✅ real Firebase Auth UID (matches your working staff)
      email: email,                             // ✅ helps lookup/debugging
      fullName: userData?.name || "",
      phone: userData?.phone || "",
      maxHours: userData?.maxHours || "40",
      daysAvailable: ["Mon", "Tue", "Wed", "Thu", "Fri"],
      isActive: true,
      createdAt: serverTimestamp(),
    });

    alert("User is now staff (staff record created).");
  } catch (err) {
    console.error("Error toggling staff:", err);
    alert("Failed to update staff status");
  }
};


const toggleAdminRole = async (userId, currentRole) => {
  try {
    const newRole = currentRole === "admin" ? "user" : "admin";

    await updateDoc(doc(db, "users", userId), {
      role: newRole,
      roleUpdatedAt: serverTimestamp(),
    });

    // Update UI instantly
    setUsers((prev) =>
      prev.map((u) => (u.id === userId ? { ...u, role: newRole } : u))
    );

    alert(`Role updated: ${newRole.toUpperCase()}`);
  } catch (err) {
    console.error("Error toggling admin:", err);
    alert("Failed to update admin status");
  }
};








// ────────────────────────────────
// 🔧 Data Maintenance Utility
// ────────────────────────────────
const [maintLog, setMaintLog] = useState([]);
const [maintRunning, setMaintRunning] = useState(false);

const appendLog = (msg) =>
  setMaintLog((prev) => [...prev, `[${new Date().toLocaleTimeString()}] ${msg}`]);
const backfillAuthUids = async () => {
  setMaintRunning(true);
  setMaintLog([]);
  appendLog("🚀 Starting full data maintenance...");

  try {
    // STEP 1️⃣: Load all staff
    const staffSnap = await getDocs(collection(db, "staff"));
    const staffMap = {};
    staffSnap.forEach((s) => (staffMap[s.id] = s.data()));
    appendLog(`📋 Loaded ${staffSnap.size} staff records.`);

    // STEP 2️⃣: Backfill Shifts with authUid
    const shiftSnap = await getDocs(collection(db, "shifts"));
    let updatedShifts = 0;

    for (const s of shiftSnap.docs) {
      const d = s.data();
      const staffData = staffMap[d.staffId];
      if (!d.authUid && staffData?.authUid) {
        await updateDoc(s.ref, { authUid: staffData.authUid });
        updatedShifts++;
        appendLog(`✅ Shift ${s.id} → added authUid (${staffData.fullName})`);
      }
    }

    appendLog(`✔ Finished updating ${updatedShifts} shifts.`);

    // STEP 3️⃣: Sync Shifts into Rotas
    let rotaCreated = 0;
    let rotaUpdated = 0;
    const allShifts = shiftSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    // Group shifts by date
    const shiftsByDate = {};
    allShifts.forEach((shift) => {
      if (!shift.date) return;
      if (!shiftsByDate[shift.date]) shiftsByDate[shift.date] = [];
      shiftsByDate[shift.date].push(shift);
    });

    for (const [date, shiftsForDate] of Object.entries(shiftsByDate)) {
      const rotaRef = doc(db, "rotas", date);
      const rotaSnap = await getDoc(rotaRef);

      const formattedShifts = shiftsForDate.map((shift) => ({
        shiftId: shift.id,
        staffId: shift.staffId,
        staffName: shift.staffName || staffMap[shift.staffId]?.fullName || "Unknown",
        authUid:
          shift.authUid || staffMap[shift.staffId]?.authUid || null,
        clientName: shift.clientName || "N/A",
        date: shift.date,
        startTime: shift.startTime,
        endTime: shift.endTime,
        status: shift.status || "Assigned",
        rate: shift.rate || 0,
      }));

      if (rotaSnap.exists()) {
        const data = rotaSnap.data();
        const existing = Array.isArray(data.shifts) ? data.shifts : [];
        const updated = [...existing];

        // Add missing shifts (avoid duplicates)
        formattedShifts.forEach((s) => {
          const exists = existing.some((e) => e.shiftId === s.shiftId);
          if (!exists) updated.push(s);
        });

        await updateDoc(rotaRef, { shifts: updated });
        rotaUpdated++;
      } else {
        await setDoc(rotaRef, {
          date,
          shifts: formattedShifts,
          createdAt: new Date().toISOString(),
        });
        rotaCreated++;
      }
    }

    appendLog(
      `📅 Synced ${rotaUpdated} existing rotas and created ${rotaCreated} new ones.`
    );

    // STEP 4️⃣: Optional Timesheet Fix (can be added later)
    // const tsSnap = await getDocs(collection(db, "timesheets"));
    // for (const t of tsSnap.docs) {
    //   const d = t.data();
    //   if (!d.authUid && d.staffId && staffMap[d.staffId]?.authUid) {
    //     await updateDoc(t.ref, { authUid: staffMap[d.staffId].authUid });
    //   }
    // }

    appendLog("🎉 Data maintenance complete! Everything is synced.");
  } catch (err) {
    console.error(err);
    appendLog(`❌ Error: ${err.message}`);
  } finally {
    setMaintRunning(false);
  }
};








  return (
    <div
      style={{
        paddingTop: "90px",
        minHeight: "100vh",
        backgroundColor: "rgba(55,65,81,0.8)",
        color: "#f3f4f6",
        padding: "1.5rem",
      }}
    >
      {/* Page Header */}
      <h1
        style={{
          textAlign: "center",
          color: "gray",
          backgroundColor: "white",
          padding: "14px 28px",
          borderRadius: "20px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          width: "fit-content",
          marginTop: "90px",
		  marginBottom: "50px",
          fontSize: "16px",
          fontWeight: "500",
        }}
      >
        User Management & Compliance
      </h1>
	  
	  <div
		  onClick={() => navigate("/admin/compliance")}
		  style={{
			backgroundColor: "#1e3a8a",
			color: "white",
			padding: "14px 18px",
			borderRadius: "12px",
			fontSize: "15px",
			fontWeight: "600",
			cursor: "pointer",
			boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			width: "100%",
			marginBottom: "18px",
			marginTop: "5px",
			userSelect: "none",
			transition: "transform 0.15s ease",
		  }}
		  onMouseDown={(e) => {
			e.currentTarget.style.transform = "scale(0.98)";
		  }}
		  onMouseUp={(e) => {
			e.currentTarget.style.transform = "scale(1)";
		  }}
		  onMouseLeave={(e) => {
			e.currentTarget.style.transform = "scale(1)";
		  }}
		>
		  📊 View Staff Compliance Overview
		</div>


      {/* Main Content */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="flex flex-col md:flex-row gap-6"
      >
        {/* LEFT: User List */}
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "16px",
            padding: "20px",
            flex: "1",
            color: "#1f2937",
            boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
          }}
        >
          <h2 style={{ fontWeight: "700", fontSize: "18px", marginBottom: "10px" }}>
            Staff Members
          </h2>
          {users.length > 0 ? (
            users.map((u) => (
              <div
                key={u.id}
                style={{
					background: "#fff",
					padding: "16px",
					borderRadius: "12px",
					marginBottom: "12px",
					boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
					width: "100%",
				  }}
              >
                <div>
                  <p style={{ textAlign: "center",  fontSize: "18px", fontWeight: "600", marginBottom: "4px" }}>{u.name}</p>
                  <p style={{ textAlign: "center", fontSize: "14px", color: "#777", marginBottom: "6px" }}>{u.email}</p>
                  <p style={{ textAlign: "center", fontSize: "13px", color: "#999", marginBottom: "12px" }}>
                    Role: {u.role}
                  </p>
                </div>
                <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "12px",
      flexWrap: "wrap",
      width: "100%",
    }}>
  {/* Role Toggle Button */}
  <button
    onClick={() => toggleUserRole(u.id, u.role, u)}

    style={{
      padding: "8px 12px",
      backgroundColor: u.role === "staff" ? "#dc2626" : "#16a34a", // red = demote, green = promote
      color: "white",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "12px",
      fontWeight: "600",
      width: "110px",
    }}
  >
    {u.role === "staff" ? "Remove Staff" : "Make Staff"}
  </button>
  
  <button
  onClick={() => toggleAdminRole(u.id, u.role)}
  style={{
    padding: "8px 12px",
    backgroundColor: u.role === "admin" ? "#dc2626" : "#7c3aed", // red remove, purple make
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "600",
    width: "110px",
  }}
>
  {u.role === "admin" ? "Remove Admin" : "Make Admin"}
</button>



  {/* Existing Manage Button */}
  <button
    onClick={() => openChat(u)}
    style={{
      backgroundColor: "#1e3a8a",
      color: "white",
      padding: "8px 16px",
      borderRadius: "8px",
      fontSize: "12px",
      fontWeight: "600",
      cursor: "pointer",
      border: "none",
    }}
  >
    Manage
  </button>
  
 


</div>

              </div>
            ))
          ) : (
            <p style={{ color: "#6b7280" }}>No users found.</p>
          )}
        </div>

        {/* RIGHT: Chat + Compliance */}
        {selectedUser && (
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4 }}
            style={{
              flex: "2",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            {/* Chat Section */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "16px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
                overflow: "hidden",
				marginTop:"50px"
              }}
            >
              <div
                style={{
                  backgroundColor: "#1e3a8a",
                  color: "white",
                  padding: "10px 16px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3 style={{ fontSize: "15px", fontWeight: "600" }}>
                  Chat with {selectedUser.name || selectedUser.email}
                </h3>
                <button
                  onClick={() => {
                    setSelectedUser(null);
                    setMessages([]);
                    setComplianceDocs([]);
                  }}
                  style={{
                    background: "transparent",
                    color: "white",
                    fontSize: "13px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  ✖ Close
                </button>
              </div>

              {/* Messages */}
              <div
                style={{
                  padding: "16px",
                  height: "220px",
                  overflowY: "auto",
                  backgroundColor: "#f9fafb",
                }}
              >
                {messages.map((msg, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      justifyContent:
                        msg.senderEmail === "admin@convalesce.com"
                          ? "flex-end"
                          : "flex-start",
                      marginBottom: "6px",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor:
                          msg.senderEmail === "admin@convalesce.com"
                            ? "#1e3a8a"
                            : "white",
                        color:
                          msg.senderEmail === "admin@convalesce.com"
                            ? "white"
                            : "#1f2937",
                        padding: "8px 12px",
                        borderRadius: "12px",
                        maxWidth: "70%",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        fontSize: "13px",
                      }}
                    >
                      {msg.text}
                    </div>
                  </div>
                ))}
              </div>

              {/* Input */}
              <form
                onSubmit={sendMessage}
                style={{
                  display: "flex",
                  borderTop: "1px solid #e5e7eb",
                  padding: "8px 12px",
                  backgroundColor: "white",
                }}
              >
                <input
                  type="text"
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  placeholder="Type a message..."
                  style={{
                    flex: 1,
                    border: "1px solid #d1d5db",
                    borderRadius: "10px",
                    padding: "8px",
                    marginRight: "8px",
                  }}
                />
                <button
                  type="submit"
                  style={{
                    backgroundColor: "#1e3a8a",
                    color: "white",
                    padding: "8px 16px",
                    borderRadius: "10px",
                    border: "none",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Send
                </button>
              </form>
            </div>

            {/* Compliance Section */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "16px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
                padding: "20px",
              }}
            >
              <h3
                style={{
                  fontSize: "15px",
                  fontWeight: "700",
                  marginBottom: "10px",
                  color: "#1f2937",
                }}
              >
                Compliance Documents
              </h3>
				
				

				
				
				
				
				
				
				
              {complianceDocs.length > 0 ? (
                <div style={{ overflowX: "auto" }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "13px",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: "#f3f4f6",
                        textAlign: "left",
                      }}
                    >
                      <tr>
                        <th style={{ padding: "8px", color: "black", }}>Document</th>
                        <th style={{ padding: "8px", color: "black", }}>Status</th>
                        <th style={{ padding: "8px", color: "black",  }}>Uploaded</th>
                        <th style={{ padding: "8px", color: "black", }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {complianceDocs.map((doc) => (
                        <tr key={doc.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                          <td style={{ padding: "8px", color: "blue", }}>{doc.name || doc.id}</td>
                          <td style={{ padding: "8px", color: "blue", }}>
                            <span
                              style={{
                                color:
                                  doc.status === "Verified"
                                    ? "#16a34a"
                                    : doc.status === "Pending Review"
                                    ? "#ca8a04"
                                    : "#dc2626",
                                fontWeight: "600",
                              }}
                            >
                              {doc.status || "Missing"}
                            </span>
                          </td>
                          <td style={{ padding: "8px",  color: "blue", }}>
                            {doc.uploadedAt
                              ? new Date(
                                  doc.uploadedAt.seconds * 1000
                                ).toLocaleDateString()
                              : "-"}
                          </td>
                          <td style={{ padding: "8px" }}>
                            {doc.url && (
                              <a
                                href={doc.url}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#2563eb",
                                  textDecoration: "underline",
                                  marginRight: "8px",
                                }}
                              >
                                View
                              </a>
                            )}
                            <button
                              onClick={() =>
                                updateStatus(selectedUser.id, doc.id, "Verified")
                              }
                              style={{
                                backgroundColor: "#16a34a",
                                color: "blue",
                                padding: "4px 10px",
                                borderRadius: "8px",
                                border: "none",
                                marginRight: "4px",
                                cursor: "pointer",
                              }}
                            >
                              ✅ Verify
                            </button>
                            <button
                              onClick={() =>
                                updateStatus(selectedUser.id, doc.id, "Rejected")
                              }
                              style={{
                                backgroundColor: "#dc2626",
                                color: "white",
                                padding: "4px 10px",
                                borderRadius: "8px",
                                border: "none",
                                cursor: "pointer",
                              }}
                            >
                              ❌ Reject
                            </button>
							
							
							<button
  onClick={() =>
    navigate(`/admin/forms/${selectedUser.id}/${doc.id}`)
  }
  style={{
    padding: "4px 10px",
    backgroundColor: "#1e3a8a",
    color: "white",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    marginRight: "8px",
    fontSize: "12px",
  }}
>
  View Form
</button>

                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p style={{ color: "#6b7280", fontSize: "13px" }}>
                  No documents uploaded yet for this user.
                </p>
              )}
            </div>
			
			
			
          </motion.div>
		  
		  
		  
		  
        )}
		
		
		
		
		
		
		{/* ────────────────────────────────   🔧 Maintenance Tools──────────────────────────────── */}
<div
  style={{
    backgroundColor: "white",
    borderRadius: "16px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
    padding: "20px",
    marginTop: "40px",
  }}
>
  <h3
    style={{
      fontSize: "15px",
      fontWeight: "700",
      marginBottom: "10px",
      color: "#1f2937",
    }}
  >
    System Maintenance
  </h3>
  <p style={{ color: "#6b7280", fontSize: "13px", marginBottom: "10px" }}>
    Run this if some staff or shifts are missing <code>authUid</code> fields.
  </p>

  <button
    onClick={backfillAuthUids}
    disabled={maintRunning}
    style={{
      backgroundColor: maintRunning ? "#9ca3af" : "#0284c7",
      color: "white",
      padding: "8px 14px",
      borderRadius: "10px",
      fontWeight: "600",
      cursor: maintRunning ? "not-allowed" : "pointer",
    }}
  >
    {maintRunning ? "Running..." : "🔄 Backfill Missing authUid Fields"}
  </button>

  <div
    style={{
      backgroundColor: "#f9fafb",
      borderRadius: "10px",
      marginTop: "12px",
      padding: "10px",
      height: "150px",
      overflowY: "auto",
      fontSize: "12px",
      color: "#374151",
    }}
  >
    {maintLog.map((line, i) => (
      <div key={i}>{line}</div>
    ))}
  </div>
</div>

      </motion.div>
    </div>
  );
}
